import React from 'react';
import Button from '@material-ui/core/Button';
import MuiDialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import PropTypes from 'prop-types';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Dialog = ({ open, onAction, children }) => {
  return (
    <MuiDialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => onAction(false)}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title">{'Are you sure want to logout?'}</DialogTitle>
      {children && (
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">{children}</DialogContentText>
        </DialogContent>
      )}
      <DialogActions>
        <Button onClick={() => onAction(false)} color="primary">
          No
        </Button>
        <Button onClick={() => onAction(true)} color="secondary">
          Logout
        </Button>
      </DialogActions>
    </MuiDialog>
  );
};

Dialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onAction: PropTypes.func,
  children: PropTypes.any,
};
Dialog.defaultProps = {
  onAction: null,
  children: null,
};

export default React.memo(Dialog);
